/**
 * Utility functions for generating gender-appropriate avatars
 */

/**
 * Generate a gender-appropriate avatar URL using DiceBear API
 * @param {string} email - User's email for seed
 * @param {string} gender - User's gender ('m' for male, 'f' for female, or other)
 * @returns {string} Avatar URL
 */
export const generateAvatarUrl = (email, gender) => {
  if (!email) return `https://api.dicebear.com/9.x/initials/svg?seed=U`
  
  // Using DiceBear initials style for cleaner look without fake profile pics
  return `https://api.dicebear.com/9.x/initials/svg?seed=${encodeURIComponent(email)}`
}

/**
 * Get user avatar with fallback to generated avatar
 * @param {object} user - User object
 * @param {string} user.avatar - Custom avatar URL
 * @param {string} user.profilePicture - Alternative avatar field
 * @param {string} user.email - User's email
 * @param {string} user.gender - User's gender
 * @param {object} userProfile - Optional user profile object with additional data
 * @returns {string} Avatar URL
 */
export const getUserAvatarUrl = (user, userProfile = null) => {
  if (!user) return generateAvatarUrl('default', null)
  
  // Use custom avatar if available
  if (user.avatar || user.profilePicture) {
    return user.avatar || user.profilePicture
  }
  
  // Get gender from user object or userProfile
  const gender = user.gender || userProfile?.gender
  
  // Generate gender-appropriate avatar
  return generateAvatarUrl(user.email || 'user', gender)
}